import { FC } from 'react'

import { Button, Placeholder } from '~ui'
import { useActions, useStore } from 'components/contexts/event-page-filters'
import { SORT_PRICE_H_TO_L, SORT_PRICE_L_TO_H } from 'components/contexts/event-page-filters/utils'

import styles from './sort.module.scss'

const sortOptions = [
  {
    label: 'Low to High',
    value: SORT_PRICE_L_TO_H,
  },
  {
    label: 'High to Low',
    value: SORT_PRICE_H_TO_L,
  },
]

const EventMenuSort: FC = () => {
  const { sort, loading } = useStore()
  const { setSort } = useActions()

  if (loading) {
    return <Placeholder style={{ width: 180, height: '45px', borderRadius: 8 }} />
  }

  return (
    <>
      {sortOptions.map((sortOption) => (
        <Button
          key={sortOption.label}
          uppercase={false}
          variant="primary"
          clr="g-green-dark"
          defaultGlow={sort === sortOption.value ? 'g-green-dark' : undefined}
          className={styles.label}
          onClick={() => setSort(sortOption.value)}
        >
          {sortOption.label}
        </Button>
      ))}
    </>
  )
}

export default EventMenuSort
